<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Audit Logs'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!isFiltersLoaded">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Audit Logs'" />
          <div class="desktop-nav-search">
            <form [formGroup]="searchForm" novalidate action="#">
              <tidy-input
                #searchInput
                class="search-input"
                [icon]="'assets/svg/search.svg'"
                [noBorder]="true"
                type="search"
                formControlName="search"
                [form]="searchForm" />
            </form>
          </div>
          <form
            [formGroup]="form"
            novalidate
            action="#"
            style="display: flex">
            <div class="desktop-item desktop-message-item">
              <tidy-select
                class="search-input"
                [icon]="'assets/svg/flag.svg'"
                [items]="statusList"
                [multiple]="false"
                [form]="form.get('status')"
                formControlName="status"
                (optionChange)="onFilterValueChange()" />
            </div>
            <div class="desktop-item desktop-message-item">
              <tidy-select
                class="search-input"
                [icon]="'assets/svg/home.svg'"
                [items]="addressFilter"
                [multiple]="true"
                [form]="form.get('selectedAddress')"
                formControlName="selectedAddress"
                (optionChange)="onFilterValueChange()" />
            </div>
          </form>
        </div>
      </tidy-desktop-header>
    }

    <tidy-row />

    @if (loaded) {
      @if (workflowItems?.length == 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No workflows added yet. Add workflows to view the run history here.'" />
          </tidy-row>
        </tidy-alert>
      }
      @if (workflowItems?.length > 0) {
        <tidy-row>
          <tidy-filter
            [initValue]="0"
            [items]="workflowItems"
            [fitContent]="true"
            (optionChange)="selectWorkflow($event)"
            class="align-center" />
        </tidy-row>
      }
      <!-- <tidy-row class="daterange-card">
        <div style="
        background: white;
        border-radius: 100px;
        padding: 5px 20px 5px 20px;
        display: block;
        box-shadow: 0 1px 6px #0000003d;
        font-size: 16px;
        width: 250px;
        margin: auto;
        max-width: 80%">
        <tidy-daterange
          [label]="'Date Range'"
          (customDateOption)="selectCustomDateRange($event)"
          (stringDateOption)="selectStringDateRange($event)"
          [(dateRangeForm)]="dateRangeForm"
          [selectOptions]="selectOptions"
          [rangeOption]="true">
        </tidy-daterange>
      </div>
    </tidy-row> -->
    @if (isFiltersLoaded && !windowService.isDesktopRes) {
      <ion-row style="margin-bottom: 0px">
        <ion-col style="padding: 0px; padding-bottom: 10px">
          <form [formGroup]="searchForm" novalidate action="#">
            <tidy-input
              #searchInput
              class="white-search-input"
              [icon]="'assets/svg/search.svg'"
              [noBorder]="true"
              type="search"
              formControlName="search"
              [form]="searchForm" />
          </form>
        </ion-col>
      </ion-row>
      <form
        [formGroup]="form"
        novalidate
        action="#">
        <ion-row>
          <ion-col style="padding: 0px; padding-bottom: 10px">
            <tidy-select
              class="white-search-input"
              [icon]="'assets/svg/flag.svg'"
              [items]="statusList"
              [multiple]="false"
              [form]="form.get('status')"
              formControlName="status"
              (optionChange)="onFilterValueChange()" />
          </ion-col>
          <ion-col style="padding: 0px">
            <tidy-select
              class="white-search-input"
              [icon]="'assets/svg/home.svg'"
              [items]="addressFilter"
              [multiple]="true"
              [form]="form.get('selectedAddress')"
              formControlName="selectedAddress"
              (optionChange)="onFilterValueChange()" />
          </ion-col>
        </ion-row>
      </form>
    }
    @if (!isFiltersLoaded && !windowService.isDesktopRes) {
      <ion-skeleton-text
        animated="true"
          style="
            width: 573px;
            height: 40px;
            border-radius: 6px;" />
    }
    @if (history?.length == 0 && workflowsLoaded) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="'No history in this range.'" />
        </tidy-row>
      </tidy-alert>
    }
    @if (loaded) {
      @for (guestReservationSyncRun of history; track guestReservationSyncRun) {
        <tidy-card>
          <tidy-card-button (action)="goToReservationSyncRunPage(guestReservationSyncRun)">
            <tidy-row class="vertical-align-middle" [alignLastItemRight]="true">
              <div style="margin-right: 20px">
                <tidy-image
                  [src]="guestReservationSyncRun?.guest_reservation_source_type?.logo_url"
                  style="width:35px" />
              </div>
              <div>
                <tidy-text
                  [header]="guestReservationSyncRun?.guest_reservation_source_type?.name" /><br>
                <tidy-text
                  [helper]="(guestReservationSyncRun?.created_at | parseDateTime:'MMM d':'local') + ' ' + (guestReservationSyncRun?.created_at | parseDateTime:'h:mma':'local')" />
              </div>
              <div style="margin-right: 20px">
                <tidy-image
                  [src]="guestReservationSyncRun?.status === 'failure' ? 'assets/img/block.svg' : 'assets/img/checkmark.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="guestReservationSyncRun?.status | titlecase" />
              </div>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
    }
  }

  @if (!loaded) {
    @for (item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track item) {
      <tidy-card>
        <tidy-card-button>
          <tidy-row class="vertical-align-middle" [alignLastItemRight]="true">
            <div style="width:20%">
              <ion-skeleton-text animated style="width: 70%; height: 20px" />
            </div>
            <div style="width:15%; display: flex">
              <ion-skeleton-text animated style="height: 40px" />
              <ion-skeleton-text animated style="height: 40px" />
            </div>
            <div style="width:25%; margin-left:30px">
              <ion-skeleton-text animated style="width: 80%; height: 20px" />
              <ion-skeleton-text animated style="height: 20px" />
            </div>
            <div>
            </div>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
  }

  @if (history?.length > 0) {
    <mat-paginator
      style="background: none"
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="selectPage($event)" />
  }

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />
